import { Col, DatePicker, Form, message, Row, Space } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntTransport } from "../../../../models/transport";
import dayjs, { Dayjs } from "dayjs";
import { SelectTerritorialUnits } from "../../../../components/selects";
import { EntAgroTransportItem } from "../../../../models/agroTransportItem";
import { dateFormat } from "../../../../utils";
import { TransportItems } from "./TransportItems";

enum FormField {
    id, // Уникальный идентификатор записи в реестре транспорта (для обновления)
    territorialUnitId, // Идентификатор территориальной единицы (обязательно)
    periodStart, // Дата начала периода в формате yyyy-MM-dd (обязательно)
    periodEnd, // Дата окончания периода в формате yyyy-MM-dd
    totalQuantity, // Количество единиц транспорта (минимум: 0)
}

interface IProps {
    show: boolean;
    transport: EntTransport;
    onHide: () => void;
    onSubmit: (pos: EntTransport) => Promise<boolean>;
}

export const AddTransportModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [checkStatus, setCheckStatus] = useState<boolean>(false);
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [items, setItems] = useState<EntAgroTransportItem[] | null>(null);

    useEffect(() => {
        if (props.show) {
            setFieldsFromEntity();
        }
    }, [props.show]);

    const setFieldsFromEntity = (): void => {


        form.setFields([
            { name: FormField.territorialUnitId, value: props.transport.territorialUnit?.id },
            {
                name: FormField.periodStart,
                value: props.transport.periodStart === null ? undefined : dayjs(props.transport.periodStart)
            },
            {
                name: FormField.periodEnd,
                value: props.transport.periodEnd === null ? undefined : dayjs(props.transport.periodEnd)
            },

        ]);

        if (props.transport.details !== null) {
            setItems(props.transport.details)
        }
    };

    const setEntityFromFields = (): EntTransport => {
        let res = _.cloneDeep(props.transport);
        res.territorialUnitId = form.getFieldValue(FormField.territorialUnitId);
        res.periodStart = form.getFieldValue(FormField.periodStart);
        res.periodEnd = form.getFieldValue(FormField.periodEnd);
        res.details = items;

        return res;
    };
    const hideModal = () => {
        props.onHide();
        setCheckStatus(false)
        setItems(null)
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();

            if (!data.details || data.details.length === 0) {
                throw new Error("Список транспортных средств не должен быть пустым!");
            }

            const invalidRegisters = data.details.filter(
                (register: EntAgroTransportItem) =>
                    register.totalQuantity === null || register.typeId === null
            );

            if (invalidRegisters.length > 0) {
                throw new Error("У всех элементов транспорт и количество должны быть заполнены!");
            }

            const result = await props.onSubmit(data);
            if (result) hideModal();
        } catch (error: any) {
            message.error(error.message || "Произошла ошибка при отправке формы.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <DraggableModal
                title={props.transport.id === null ? t("mechanisation.transport.add_transport") : t("mechanisation.transport.edit_transport")}
                visible={props.show}
                onCancel={() => {
                    hideModal()
                }}
                onSubmit={handleSubmit}
                submitLoading={loading}
                width={800}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Row style={{ margin: 0 }} gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <Space.Compact>
                                <Form.Item
                                    label={t('general.start_date_period')}
                                    name={FormField.periodStart}
                                    rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                >
                                    <DatePicker
                                        format={dateFormat}
                                        placeholder={t('general.select_date')} onChange={(date) => setStartDate(date)} />

                                </Form.Item>
                                <Form.Item
                                    label={t('general.end_date_period')}
                                    name={FormField.periodEnd}
                                    rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                >
                                    <DatePicker
                                        format={dateFormat}
                                        placeholder={t('general.select_date')}
                                        disabledDate={(current) =>
                                            !!startDate && current.isBefore(startDate.add(1, "day"), "day")
                                        }
                                    />
                                </Form.Item>
                            </Space.Compact>



                        </Col>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label={t('general.territorial_unit')}
                                name={FormField.territorialUnitId}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <SelectTerritorialUnits type={['REGION']} />
                            </Form.Item>

                        </Col>
                        <Col className="gutter-row" span={24}>
                            <TransportItems setItems={setItems} items={items} />
                        </Col>

                    </Row>

                </Form>
            </DraggableModal>
        </>
    );
};
